import React, { useContext } from 'react';
import { ComponentContext } from '../../../contexts';
import { degreesToRadians, SEAT_CIRCLE_DIAMETER, SEAT_CIRCLE_RADIUS, SEAT_SPACING } from '../../..';
import { createLabelGenerator } from '../../../utils/label-generator';
export const RoundTableSeats = ({ ellipseDiameter, definition }) => {
    const { Seat } = useContext(ComponentContext);
    const positions = getSeatPositions(definition, ellipseDiameter);
    const labelGenerator = createLabelGenerator(definition);
    return (React.createElement(React.Fragment, null, positions.filter(Boolean).map((position, index) => {
        const label = labelGenerator.getLabelByIndex(index);
        return React.createElement(Seat, { key: label, x: position.x, y: position.y, definition: definition, label: label, index: index });
    })));
};
const getSeatPositions = (definition, ellipseDiameter) => {
    const { capacity, empty } = definition;
    const spacingBetweenSeats = 360 / (capacity + empty);
    const seatsInfo = [];
    // Populate (fill is not suitable for objects due to reference problems)
    for (let i = 0; i < empty + capacity; i++) {
        seatsInfo.push({ degrees: 0, empty: false });
    }
    // Mark empty seats
    for (let i = 0; i < empty; i++) {
        const emptyIndex = !(i % 2) ? i / 2 : seatsInfo.length - Math.ceil(i / 2);
        seatsInfo[emptyIndex].empty = true;
    }
    // Set degrees
    for (let i = 0; i < seatsInfo.length; i++) {
        const offsetForEmptySeatCentering = empty && !(empty % 2) ? -(spacingBetweenSeats / 2) : 0;
        // Inverting index for clock-wise drawing (by default it would be counter-clock-wise)
        const invertedIndex = (seatsInfo.length - i) % seatsInfo.length;
        seatsInfo[invertedIndex].degrees = (spacingBetweenSeats * i + offsetForEmptySeatCentering + 180) % 360;
    }
    // Calculate positions
    // Return only non empty seat positions
    const positions = seatsInfo
        .filter(({ empty: noSeats }) => !noSeats)
        .map(({ degrees }) => getSeatPosition(degrees, ellipseDiameter));
    return positions;
};
const getSeatPosition = (degrees, ellipseDiameter) => {
    const angle = degreesToRadians(degrees);
    const seatCenterCircleRadius = ellipseDiameter / 2 + SEAT_SPACING + SEAT_CIRCLE_RADIUS;
    const x = seatCenterCircleRadius * Math.sin(angle) + ellipseDiameter / 2 + SEAT_CIRCLE_DIAMETER;
    const y = seatCenterCircleRadius * Math.cos(angle) + ellipseDiameter / 2 + SEAT_CIRCLE_DIAMETER;
    return { x, y };
};
//# sourceMappingURL=round-table-seats.js.map